export const APP_STORE_LINK = {
  ANDROID:
    "https://play.google.com/store/apps/details?id=com.letsfip.pilot&referrer=utm_source%3Dletsfip%26utm_medium%3Dappdownload%26utm_campaign%3Dlaunch%26anid%3Dadmob",
  IOS: "itms-apps://itunes.apple.com/app/id6497171060?pt=letsfip&ct=appdownload&mt=8",
};
